module.exports = require("@mui/icons-material/ArrowBackIos");